import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	bottom: 120px;
`;

const StyledHorizontalList = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
	padding: 0 60px;
	overflow-x: scroll;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledControlsContainer = styled.div`
	position: absolute;
	left: 60px;
	right: 60px;
	bottom: 60px;
	display: flex;
	justify-content: space-between;
`;

export { StyledContainer, StyledControlsContainer, StyledHorizontalList };
